__webpack_require__.p = "/mini-monster-pages/";